import SettingItem from '../settingItem/SettingItem';
import AccountPermission from '../../components/accountPermission/AccountPermission';

function TicketsMailingForm() {
    
    return (
        <>
            <AccountPermission permission="whatsApp">
                <SettingItem 
                    name={'whatsAppMessage'} 
                    settingCategory={'ticketsMailing'}
                />
            </AccountPermission>
        </>
    );
}

export default TicketsMailingForm; 